import { h, Component } from 'preact';
// import PageLink from 'components/pageLink/pageLink';
// import Store from 'store/store';
// import * as actions from 'store/actions';

import s from 'components/pages/error-404/error-404.sss';

export default class Error404 extends Component {

	render() {
		return (
			<div class={s.wrapper}>
				<h2 class={s.title}>404</h2>
				<p class={s.content}>This page could not be found.</p>
				{/* <PageLink to={'landing'} class={s.link}>Return to home</PageLink> */}
			</div>
		);
	}

}